import { motion } from "framer-motion";

const fabrics = [
  { name: "Cotone", season: "Tutto l'anno", color: "#A7C4B5", bg: "#EAF0EC",
    desc: "Morbido e traspirante, delicato sulla pelle del neonato. La base di ogni corredino.",
    care: "Lavaggio a 30°C" },
  { name: "Ciniglia", season: "Autunno · Inverno", color: "#C87D75", bg: "#F9ECE9",
    desc: "Calda e avvolgente, perfetta per copertine e tutine nelle stagioni fredde.",
    care: "Lavaggio delicato 30°C" },
  { name: "Velluto", season: "Inverno", color: "#4A7496", bg: "#EBF3F8",
    desc: "Elegante e caldo, ideale per completini delle occasioni speciali invernali.",
    care: "Lavaggio a mano" },
  { name: "Lana merino", season: "Inverno", color: "#8C7F78", bg: "#F4EFEA",
    desc: "Termoregolatrice e anallergica, mantiene il calore senza far sudare.",
    care: "Lavaggio lana a freddo" },
  { name: "Mussola", season: "Primavera · Estate", color: "#C29638", bg: "#FDF6E7",
    desc: "Garza di cotone leggerissima e traspirante, ottima per i mesi caldi e per il sonno.",
    care: "Lavaggio a 40°C" },
  { name: "Spugna", season: "Tutto l'anno", color: "#4E7363", bg: "#EAF0EC",
    desc: "Assorbente e soffice, insostituibile per il bagnetto e gli accappatoi.",
    care: "Lavaggio a 40°C" },
];

export default function FabricGuide() {
  return (
    <section id="tessuti" className="bg-[#F4EFEA]">
      <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-12 py-10 sm:py-14 lg:py-20">
        <div className="mb-8">
          <span className="text-xs uppercase tracking-[0.2em] font-semibold text-[#8C7F78]">Guida ai tessuti</span>
          <h2 className="font-serif text-3xl sm:text-4xl text-[#2D2825] mt-2">Il tessuto giusto per ogni stagione</h2>
          <p className="text-[#5C534E] mt-2 max-w-xl">Scopri i materiali naturali che coccolano la pelle del tuo bambino.</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-testid="fabric-guide">
          {fabrics.map((f, i) => (
            <motion.div
              key={f.name} initial={{ opacity: 0, y: 14 }} whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }} transition={{ delay: (i % 3) * 0.06 }}
              data-testid={`fabric-${f.name}`}
              className="rounded-2xl bg-white border border-[#EAE3DC] p-6 transition-transform duration-300 hover:-translate-y-1"
            >
              <div className="inline-flex rounded-full px-3 py-1 text-xs font-medium mb-4"
                style={{ background: f.bg, color: f.color }}>
                {f.season}
              </div>
              <h3 className="font-serif text-2xl text-[#2D2825]">{f.name}</h3>
              <p className="text-sm text-[#5C534E] mt-2 leading-relaxed">{f.desc}</p>
              <div className="mt-4 text-xs uppercase tracking-widest text-[#8C7F78]">{f.care}</div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
